import React, { useEffect, useState } from "react";

import * as utils from "../../Utils/comman";
import * as RB from "react-bootstrap";
import { useLoader } from "../../Loader";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

function Add(props) {
  const [formData, setFormData] = useState({
    companyName: "",
    gst: "",
    address: "",
    state: "",
    district: "",
    city: "",
    isActive: "",
    pinCode: "",
  });

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);

  const [stateError, setStateError] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [cityError, setCityError] = useState("");
  const { startLoader, stopLoader } = useLoader();

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(() => {
    if (formData.state) {
      fetchDistricts(formData.state); // Fetch districts when a state is selected
    } else {
      setDistricts([]);
      setCities([]);
    }
  }, [formData.state]);

  useEffect(() => {
    if (formData.district) {
      fetchCities(formData.district); // Fetch cities when a district is selected
    } else {
      setCities([]);
    }
  }, [formData.district]);

  const fetchStates = () => {
    startLoader();
    utils
      .callAPI("get", `/state/list`)
      .then((res) => {
        setStates(res || []);
        stopLoader();
      })
      .catch(() => {
        setStates([]);
        stopLoader();
      });
  };

  const fetchDistricts = (stateId) => {
    startLoader();
    utils
      .callAPI("get", `/district/list?stateId=${stateId}`) // API to fetch districts
      .then((res) => {
        setDistricts(res || []);
        stopLoader();
      })
      .catch(() => {
        setDistricts([]);
        stopLoader();
      });
  };

  const fetchCities = (districtId) => {
    startLoader();
    utils
      .callAPI("get", `/city/by-district-list?districtId=${districtId}`) // API to fetch cities by district
      .then((res) => {
        setCities(res || []);
        stopLoader();
      })
      .catch(() => {
        setCities([]);
        stopLoader();
      });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "state" && { district: "", city: "" }),
      ...(name === "district" && { city: "" }),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props.rowData.id);
      }
      bodyFormData.append("company_name", formData.companyName);
      bodyFormData.append("gst", formData.gst);
      bodyFormData.append("address", formData.address);
      bodyFormData.append("state", formData.state);
      bodyFormData.append("district", formData.district);
      bodyFormData.append("city", formData.city?.value);
      bodyFormData.append("pin_code", formData.pinCode);
      bodyFormData.append("status", formData.isActive);

      utils
        .callAPI("post", `/billinglocation/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            setIsSubmit(false);
          }
        })
        .catch((err) => {});

      setIsSubmit(false);
    }
  }, [isSubmit]);

  const handleBackClick = () => {
    const propdata = { mode: "list" };
    props.onChange(propdata);
  };

  const status = [
    { id: "", name: "Select an option..." },
    { id: "1", name: "Active" },
    { id: "0", name: "Inactive" },
  ];

  const handleCityChange = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, city: selectedOption });
  };
  const handleCreateCity = (inputValue) => {
    const bodyFormData = new FormData();
    bodyFormData.append("state", formData.state);
    bodyFormData.append("district", formData.district);
    bodyFormData.append("city_name", inputValue);

    startLoader();
    utils
      .callAPI("post", "/travel/add-city", bodyFormData)
      .then((res) => {
        if (res) {
          // Add the newly created city to the city list
          const newCity = { value: res.city_code, label: inputValue };
          setCities((prevCities) => [...prevCities, newCity]);
          setFormData({ ...formData, city: newCity });
        }
      })
      .catch((err) => {
        console.error("Error creating city:", err);
      })
      .finally(() => {
        stopLoader();
      });
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      const data = props.rowData;

      // Set the formData with the initial values from rowData
      setFormData((prev) => ({
        ...prev,
        companyName: data.company_name || "",
        gst: data.gst || "",
        address: data.address || "",
        state: data.state || "",
        district: data.district || "",
        city:
          data.city && data.city !== "0"
            ? { label: data.city_name || "Unknown", value: data.city }
            : null,
        isActive: data.status || "",
        pinCode: data.pin_code || "",
      }));

      if (data.state && data.state !== "0") {
        fetchDistricts(data.state);
      }

      if (data.district && data.district !== "0") {
        fetchCities(data.district);
      }
    }
  }, [props.rowData]);

  const stateOptions = states.map((s) => ({
    value: s.state_code,
    label: s.state_name,
  }));

  const districtOptions = districts.map((d) => ({
    value: d.district_code,
    label: d.district_name,
  }));

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            <button
              className="btn btn-underline me-2"
              onClick={handleBackClick}
            >
              Back
            </button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row className="mb-3">
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Company Name"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    placeholder="Enter company name"
                    required
                  />
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={6}>
                <RB.FloatingLabel label="GST" className="floating-label-fancy">
                  <RB.Form.Control
                    type="text"
                    name="gst"
                    value={formData.gst}
                    onChange={handleInputChange}
                    placeholder="Enter GST number"
                    required
                  />
                </RB.FloatingLabel>
              </RB.Col>
            </RB.Row>

            <h6 className="mb-3 mt-3">Address Information</h6>
            <hr className="hr-lg mt-1" />

            <RB.Row>
              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Address"
                  className="floating-label-fancy mb-3"
                >
                  <RB.Form.Control
                    as="textarea"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    placeholder="Enter Address"
                    required
                  />
                </RB.FloatingLabel>
              </RB.Col>

              <RB.Col md={6} className="mt-3">
                <Select
                  options={stateOptions}
                  value={
                    stateOptions.find((opt) => opt.value === formData.state) ||
                    null
                  }
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      state: selected ? selected.value : "",
                      district: "",
                      city: null,
                    }))
                  }
                  placeholder="Select State..."
                  isClearable
                  className="bom-productName-select"
                />
              </RB.Col>

              <RB.Col md={6} className="mt-3 mb-2">
                <Select
                  options={districtOptions}
                  value={
                    districtOptions.find(
                      (opt) => opt.value === formData.district
                    ) || null
                  }
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      district: selected ? selected.value : "",
                      city: null,
                    }))
                  }
                  placeholder="Select District..."
                  className="bom-productName-select"
                  isClearable
                />
              </RB.Col>

              <RB.Col md={6} className="mb-2">
                <CreatableSelect
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  isClearable
                  value={formData.city}
                  onChange={(selectedOption) =>
                    handleCityChange(selectedOption)
                  }
                  onCreateOption={(inputValue) => handleCreateCity(inputValue)}
                  options={
                    cities?.map((city) => ({
                      label: city.city_name,
                      value: city.city_code,
                    })) || []
                  }
                  placeholder="Type or select a city"
                  className="mt-3"
                />
              </RB.Col>

              <RB.Col md={6}>
                <RB.FloatingLabel
                  label="Pin Code"
                  className="floating-label-fancy mb-3"
                >
                  <RB.Form.Control
                    type="text"
                    name="pinCode"
                    value={formData.pinCode}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    placeholder="Enter Pin Code"
                    maxLength={6}
                    required
                  />
                </RB.FloatingLabel>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formIsActive"
                    label="Status"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="isActive"
                      value={formData.isActive}
                      onChange={handleInputChange}
                      required
                    >
                      {status.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Button type="submit" variant="primary">
              Submit
            </RB.Button>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
